import React from 'react';
export function HoefelmeyerLogo({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex items-center ${className}`} data-id="element-184">
      <img src="https://cdn.magicpatterns.com/uploads/bQ5MWpi6sQSQoa5x28ZSLN/HofelmeyerLogo_(1)_(4).png" alt="Höfelmeyer" className="h-10 w-auto" data-id="element-185" />
    </div>;
}
export function MinebeaLogo({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex items-center ${className}`} data-id="element-186">
      <span className="font-sans font-bold tracking-wide text-slate-800 text-xl leading-none" data-id="element-187">
        Minebea Intec
      </span>
    </div>;
}